
export const SAVINGS_PLAN_STATUS = {
    GENERADO: "GENERADO",
    RESERVADO: "RESERVADO",
    SUSCRIPTO: "SUSCRIPTO",
    APROBADO: "APROBADO",
    ANULADO: "ANULADO",
    CERRADO: "CERRADO",
};

export const SAVING_PLAN_FIELDS = {
    businessAdvisor: 'businessAdvisor'
}